import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  ACCOUNT_NO_ORGANISATION_SIZE_NOTIFICATION_QUERY,
  UPDATE_ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_MUTATION,
} from '../../services/dashboard.service';
import { Dialog } from 'primereact/dialog';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import NoDataAccountOrganisationSizeNotification from './NoDataAccountOrganisationSizeNotification';

const DEFAULT_STATE = {
  id: null,
};

const AccountNoOrganisationSizeNotification = () => {
  const [notification, setNotification] = useState(DEFAULT_STATE);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { data } = useQuery(ACCOUNT_NO_ORGANISATION_SIZE_NOTIFICATION_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'network-only',
  });
  const [updateAccountOrganisationSizeNotification] = useMutation(
    UPDATE_ACCOUNT_ORGANISATION_SIZE_NOTIFICATION_MUTATION,
  );

  useEffect(() => {
    if (data && data.accountNoOrganisationSizeNotification) {
      setNotification(data.accountNoOrganisationSizeNotification);
    }
  }, [data]);

  const hide = () => setNotification(DEFAULT_STATE);

  const updateNotification = async () => {
    try {
      await updateAccountOrganisationSizeNotification({
        variables: {
          input: {
            notificationId: notification.id,
            accountId: currentAccount,
          },
        },
      });

      hide();
    } catch (error) {
      growlErrors(growl, error);
    }
  };

  return (
    <Dialog
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={notification !== DEFAULT_STATE}
      onHide={() => {}}
      position="center"
      header="Please help use improve your GDPR compliance"
    >
      <NoDataAccountOrganisationSizeNotification updateNotification={updateNotification} />
    </Dialog>
  );
};

export default AccountNoOrganisationSizeNotification;
